import { createFileRoute } from "@tanstack/react-router";
import { PaginaRota } from "@/paginas/analise-vendas";

export const Route = createFileRoute("/_authenticated/analise-vendas")({
  head: () => ({
    meta: [
      { title: "Análise de vendas — Milky Moo Palmares" },
      {
        name: "description",
        content:
          "Compare as vendas de um período por produto, volume, seção do cardápio e insumo com gráficos.",
      },
      { property: "og:title", content: "Análise de vendas — Milky Moo Palmares" },
      {
        property: "og:description",
        content: "Gráficos comparativos de vendas por produto, volume, seção do cardápio e insumo.",
      },
    ],
  }),
  component: PaginaRota,
});
